export const listToTree = (list: any[]) => {
  const map: any = {};
  const tree: any[] = [];

  list.forEach((item) => {
    map[item.navId] = { ...item, children: [] };
  });

  list.forEach((item) => {
    if (item.parentNavId && map[item.parentNavId]) {
      map[item.parentNavId].children.push(map[item.navId]);
    } else {
      tree.push(map[item.navId]);
    }
  });

  return tree;
};
